/**
 * Одно уведомление на нажатие «Создать» (решение владельца 2026-10-06). Слово и фразы
 * одного нажатия генерируются отдельными карточками, и каждая присылала свой тост «готово» —
 * на экране висело по пять штук. Теперь тосты успеха этих карточек копятся и показываются
 * одним «Готово N карточек», когда пришли все (или вышло время ожидания). Ошибки и опечатки
 * по-прежнему показываются сразу: по ним нужно действовать. В списке уведомлений (колокольчик)
 * каждая карточка остаётся отдельной записью.
 */

/** Сколько ждём остальные карточки нажатия, прежде чем показать то, что готово. */
const WAIT_MS = 3 * 60_000;

/** Карточка нажатия: id и слово. Итог группы отдаёт и id — на главной по ним решают, не
 *  отслеживаются ли карточки строкой создания (тогда тоста нет, ТЗ главной § 8). */
export interface BatchedCard {
  cardId: string;
  front: string;
}

interface Batch {
  fronts: Map<string, string>;
  pending: Set<string>;
  done: BatchedCard[];
  timer: number;
}

type Flush = (cards: BatchedCard[]) => void;

const byCard = new Map<string, Batch>();
let flushHandler: Flush | null = null;

function flush(batch: Batch) {
  window.clearTimeout(batch.timer);
  for (const id of batch.fronts.keys()) byCard.delete(id);
  if (batch.done.length) flushHandler?.(batch.done);
}

/** Слушатель уведомлений регистрирует, как показать итоговый тост. */
export function setToastBatchFlush(handler: Flush | null) {
  flushHandler = handler;
}

/** Карточки одного нажатия, которые ещё генерируются. Одна карточка — без группировки. */
export function startToastBatch(cards: BatchedCard[]) {
  const fresh = cards.filter((c) => !byCard.has(c.cardId));
  if (fresh.length < 2) return;
  const batch: Batch = {
    fronts: new Map(fresh.map((c) => [c.cardId, c.front])),
    pending: new Set(fresh.map((c) => c.cardId)),
    done: [],
    timer: 0,
  };
  batch.timer = window.setTimeout(() => flush(batch), WAIT_MS);
  for (const c of fresh) byCard.set(c.cardId, batch);
}

/**
 * Карточка закончила генерацию. true — её тост успеха поглощён группой.
 * ok=false (ошибка, опечатка) — тост показывается сразу, но карточка выходит из ожидания.
 */
export function settleBatchedCard(cardId: string, ok: boolean): boolean {
  const batch = byCard.get(cardId);
  if (!batch || !batch.pending.has(cardId)) return false;
  batch.pending.delete(cardId);
  if (ok) batch.done.push({ cardId, front: batch.fronts.get(cardId) ?? '' });
  if (batch.pending.size === 0) flush(batch);
  return ok;
}
